export enum TagAppearance {
  Tag = 'Tag',
  Badge = 'Badge',
  Status = 'Status',
}
